<script lang="ts" setup>
import ForLaywersPage from '@/pages/forLaywers';
</script>

<template>
  <ForLaywersPage />
</template>
